import { createTheme } from 'flowbite-react';

export const customTheme = createTheme({
  datepicker: {
    root: {
      base: 'relative',
      input: {
        field: {
          input: {
            base: 'cursor-pointer bg-blue-100 border-0 text-black/60 rounded-lgm hover:bg-blue-200 duration-200 w-full xs:text-lg',
            sizes: {
              md: 'px-5 py-4',
            },
            colors: {
              gray: undefined,
            },
          },
        },
      },
    },
    popup: {
      root: {
        base: 'absolute top-4 w-full',
      },
      footer: {
        base: 'mt-2 flex space-x-2',
        button: {
          base: 'w-full rounded-lg px-5 py-2 text-center text-sm font-medium focus:ring-4 focus:ring-cyan-300',
          today: 'bg-blue-600 text-white hover:bg-blue-800 duration-200',
          clear:
            'border border-gray-300 bg-white text-gray-900 hover:bg-gray-100',
        },
      },
    },
    views: {
      days: {
        items: {
          base: 'grid w-64 grid-cols-7',
          item: {
            base: 'block flex-1 cursor-pointer rounded-lg border-0 text-center text-sm font-normal font-montserrat leading-9 text-gray-900 hover:bg-blue-100',
            selected: 'bg-blue-600 text-white hover:bg-blue-800 duration-200',
            disabled: 'text-gray-400',
          },
        },
      },
    },
  },
  modal: {
    header: {
      close: {
        base: 'outline-none',
      },
      base: 'px-6 pb-4 flex w-full justify-between border-b',
      title: 'text-lg text-gray-900 ',
    },
    content: {
      base: 'relative h-full md:h-auto w-full px-4',
      inner:
        'py-4 max-h-[90dvh] rounded-3xl bg-white shadow overflow-auto w-full relative',
    },
  },
  dropdown: {
    content: 'pl-0',
    floating: {
      item: {
        container: 'list-none pl-0',
      },
    },
  },
  tooltip: {
    arrow: {
      style: {
        light: 'bg-blue-4',
        dark: 'bg-blue-4',
        auto: 'bg-blue-4',
      },
    },
  },
  spinner: {
    base: 'inline animate-spin',
    color: {
      info: 'fill-blue-1 text-white/60',
    },
  },
});
